module.exports = __webpack_public_path__ + "static/media/classicWhiteSide.4dc94752.PNG";